var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutOrangeEnPublication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2s2.2,1,2.2,2.2C14.2,17,13.2,18,12,18C12,18,12,18,12,18 M18.6,21.3V10.4H5.4v11 L18.6,21.3 M18.6,8.2c1.2,0,2.2,1,2.2,2.2c0,0,0,0,0,0v11c0,1.2-1,2.2-2.2,2.2c0,0,0,0,0,0H5.4c-1.2,0-2.2-1-2.2-2.2l0,0V10.4 c0-1.2,1-2.2,2.2-2.2c0,0,0,0,0,0h1.1V6C6.5,3,9,0.5,12,0.5S17.5,3,17.5,6v2.2L18.6,8.2 M12,2.7c-1.8,0-3.3,1.5-3.3,3.3c0,0,0,0,0,0 v2.2h6.6V6C15.3,4.2,13.8,2.7,12,2.7C12,2.7,12,2.7,12,2.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutOrangeEnPublication);
export default __webpack_public_path__ + "static/media/statut_orange_en-publication.07ab828c.svg";
export { ForwardRef as ReactComponent };